import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../lib/auth";
import { Radar, Sparkles } from "lucide-react";

export default function PolicyRadar() {
  const { activeCompany } = useAuth();
  const [briefing, setBriefing] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancel = false;
    setLoading(true);
    setError("");
    api.get("/policy-radar/briefing")
      .then(({ data }) => { if (!cancel) setBriefing(data); })
      .catch((e) => { if (!cancel) setError(formatApiErrorDetail(e.response?.data?.detail) || e.message); })
      .finally(() => { if (!cancel) setLoading(false); });
    return () => { cancel = true; };
  }, [activeCompany?.id]);

  const bullets = briefing?.bullets || [];

  return (
    <div data-testid="policy-radar-page">
      <div className="mb-6">
        <div className="label-meta flex items-center gap-2"><Radar size={11} /> Policy radar</div>
        <div className="display">UK defence policy briefing</div>
      </div>

      {error && (
        <div className="text-[12px] p-3 mb-4 border" style={{ borderColor: "#111" }} data-testid="policy-radar-error">
          {error}
        </div>
      )}

      {loading ? <span className="spinner" /> : !briefing ? null : (
        <>
          <div className="p-card mb-6" data-testid="briefing-summary">
            <div className="flex items-center gap-2 mb-3">
              <Sparkles size={14} />
              <span className="label-meta">This week's headline</span>
            </div>
            <p className="text-[22px] font-semibold leading-tight tracking-tight" style={{ maxWidth: "60ch" }}>
              {briefing.summary || "No briefing available yet."}
            </p>
          </div>

          <div data-testid="briefing-bullets">
            <div className="flex items-baseline justify-between mb-3">
              <h2 className="m-0">Key signals</h2>
              <span className="text-[11px] value-mono" style={{ color: "var(--parapet-text-secondary)" }}>
                {bullets.length} {bullets.length === 1 ? "signal" : "signals"}
              </span>
            </div>
            {bullets.length === 0 ? (
              <div className="empty-state">
                <h3>No signals generated</h3>
                <p>Run ingestion from Admin to refresh signals.</p>
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {bullets.map((b, i) => (
                  <div key={b.text || `bullet-${i}`} className="p-card flex gap-3" data-testid={`bullet-${i}`}>
                    <span
                      className="value-mono text-[11px] pt-0.5"
                      style={{
                        color: "var(--parapet-text-secondary)",
                        minWidth: 22,
                        textAlign: "right",
                      }}
                    >
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <div className="flex-1 min-w-0">
                      <p className="text-[14px] leading-relaxed">{b.text}</p>
                      {(b.sources || []).length > 0 && (
                        <div className="mt-2 flex flex-wrap gap-1">
                          {b.sources.map((s) => (
                            <span key={s} className="source-tag">{s}</span>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}
